import {useHistory} from 'react-router-dom';
import React, {useContext, useEffect, useState} from "react";
import {AuthContext} from "../../context/AuthContext";
import {useFormik} from "formik";
import {TranslateContext} from "../../context/TranslateContext";
import {loginUtenteApi} from "./services/AuthServices";
import {getUtenteFromToken} from "../../utility/common";
import LoginView from "./LoginView";
import Spinner from "../../components/Spinner";

export default function LoginController(props) {

    var hash = props?.location?.state?.hash || ''
    const history = useHistory();

    const authContext = useContext(AuthContext);
    const isLoggedIn = authContext.isLogged();

    const [showLogin, setShowLogin] = useState(false);
    const [show, setShow] = useState(false);
    const [msgModal, setMsgModal] = useState('');

    const {translate} = useContext(TranslateContext);

    const formik = useFormik({
        initialValues: {
            email: '',
            password: ''
        }, onSubmit: async values => {
            const response = await loginUtenteApi({
                username: values.email,
                pwd: values.password
            });
            if (response?.data) {
                if (response?.data?.result === 0) {
                    localStorage.setItem('ns-refresh-token', response.data.data.refresh_token);
                    localStorage.setItem('ns-access-token', response.data.data.access_token);

                    var user = getUtenteFromToken(response.data.data.access_token);
                    authContext.handleLogin(user, history, hash);
                } else {
                    setMsgModal(response.data.description)
                    setShow(true)
                }
            }
        }
    });

    useEffect(() => {
        if (isLoggedIn === true) {
            history.push("/home");
        } else if (isLoggedIn === false) {
            setShowLogin(true);
        }
    }, [isLoggedIn]);

    return (
        showLogin ?
            <LoginView
                show={show}
                setShow={setShow}
                translate={translate}
                formik={formik}
                msgModal={msgModal}
            />
            :
            <Spinner loading={true}/>
    );
}
